import FeedItem from './FeedItem.container';

export default FeedItem;
